import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _Promise from "/app/node_modules/babel-runtime/core-js/promise";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
import _extends from "/app/node_modules/babel-runtime/helpers/extends";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { stepForm, onlyNumbersMixin, onlyLettersMixin, lettersAndNumbersMixin } from "~/mixins";
import { required, email, maxLength, numeric, minLength, url } from "vuelidate/lib/validators";
import { mapState, mapMutations, mapGetters } from "vuex";
import { onlyEmail, charactersSpecial, onlyLetters,
// charactersSpecialForUrl,
noSpecialChars } from "~/validators";
import { withParams } from "vuelidate/lib/validators/common";

export default {
    mixins: [stepForm, onlyNumbersMixin, onlyLettersMixin, lettersAndNumbersMixin],
    data: function data() {
        var isPagoWeb = this.$store.state.affiliations.form.posSelected.pos === this.$virtualPosEnum.PAGO_WEB;
        var _$store$state$affilia = this.$store.state.affiliations.form.virtual,
            app = _$store$state$affilia.app,
            webSite = _$store$state$affilia.webSite;

        var developer = (isPagoWeb ? webSite : app).developer;
        var developmentStatus = [{ text: "Tercerizado", value: 1 }, { text: "Propio", value: 2 }];
        var data = {
            // pago web
            webSiteUrl: webSite.url || 'http://',
            // pago app
            nameApp: app.name,
            linkApp: app.link || 'http://',
            platform: app.platform,
            // ambos
            development: developmentStatus.filter(function (row) {
                return row.value == developer.developmentType;
            })[0],
            companyName: developer.company,
            contactName: developer.fullname,
            contactEmail: developer.email,
            contactPhone: developer.phone,
            // typeUrl: 'http://',
            // typesUrl: ['http://', 'https://'],

            developmentStatus: developmentStatus,
            platforms: ["Android", "IOS"],
            sending: false,
            isPagoWeb: isPagoWeb
        };
        return data;
    },
    validations: function validations() {
        var validations = {
            development: { required: required },
            contactName: {
                required: required,
                onlyLetters: onlyLetters("contactName"),
                charactersSpecial: charactersSpecial("contactName")
            },
            contactEmail: {
                required: required,
                // email,
                noSpecialChars: noSpecialChars("noSpecialChars"),
                emailValidate: onlyEmail("emailValidate")
            },
            contactPhone: { required: required, numeric: numeric, minLength: minLength(9) }
        };

        if (this.isOutsourced) {
            validations.companyName = {
                required: required,
                charactersSpecial: charactersSpecial("companyName")
            };
        }

        if (this.isPagoWeb) {
            validations.webSiteUrl = {
                required: required,
                url: url
                // charactersSpecialForUrl: charactersSpecialForUrl("nameWeb")
            };
        } else {
            validations.nameApp = { required: required };
            validations.linkApp = {
                required: required,
                url: url
                // charactersSpecialForUrl: charactersSpecialForUrl("linkApp")
            };
            validations.platform = { required: required };
        }

        return validations;
    },

    computed: _extends({}, mapState("master-data", {
        developmentStatusData: function developmentStatusData(state) {
            return state.development;
        },
        platformStatusData: function platformStatusData(state) {
            return state.platform;
        }
    }), {
        // ...mapGetters({
        //     isPagoWeb: "affiliations/form/isPagoWeb"
        // }),
        isOutsourced: function isOutsourced() {
            return this.development ? this.development.text.toUpperCase() === "TERCERIZADO" : false;
        },
        nameAppErrorMessages: function nameAppErrorMessages() {
            var errors = [];
            if (!this.$v.nameApp.$dirty) return errors;
            !this.$v.nameApp.required && errors.push("Campo obligatorio");
            return errors;
        },
        linkAppErrorMessages: function linkAppErrorMessages() {
            var errors = [];
            if (!this.$v.linkApp.$dirty) return errors;
            !this.$v.linkApp.required && errors.push("Campo obligatorio"), !this.$v.linkApp.url && errors.push("Ingresa una dirección url válida");
            return errors;
        },
        webSiteUrlErrorMessages: function webSiteUrlErrorMessages() {
            var errors = [];
            if (!this.$v.webSiteUrl.$dirty) return errors;
            !this.$v.webSiteUrl.required && errors.push("Campo obligatorio"), !this.$v.webSiteUrl.url && errors.push("Ingresa una dirección url válida"), this.$v.webSiteUrl.restringCharactersSpecial && errors.push("Caracter inválido");
            return errors;
        },
        companyNameErrorMessages: function companyNameErrorMessages() {
            var errors = [];
            if (!this.$v.companyName.$dirty) return errors;
            !this.$v.companyName.required && errors.push("Campo obligatorio"), !this.$v.companyName.charactersSpecial && errors.push("Caracter inválido");
            return errors;
        },
        contactNameErrorMessages: function contactNameErrorMessages() {
            var errors = [];
            if (!this.$v.contactName.$dirty) return errors;
            !this.$v.contactName.required && errors.push("Campo obligatorio"), !this.$v.contactName.charactersSpecial && errors.push("No puedes escribir ñ, &, | ó tildes"), !this.$v.contactName.onlyLetters && errors.push("Ingrese sólo letras");

            return errors;
        },
        contactEmailErrorMessages: function contactEmailErrorMessages() {
            var errors = [];
            if (!this.$v.contactEmail.$dirty) return errors;
            !this.$v.contactEmail.required && errors.push("Campo obligatorio");
            !this.$v.contactEmail.noSpecialChars && errors.push("No puede ingresar caracteres espciales"), !this.$v.contactEmail.emailValidate && errors.push("Ingresa un email válido");
            return errors;
        },
        contactPhoneErrorMessages: function contactPhoneErrorMessages() {
            var errors = [];
            if (!this.$v.contactPhone.$dirty) return errors;
            !this.$v.contactPhone.required && errors.push("Campo obligatorio"), !this.$v.contactPhone.numeric && errors.push("Ingresa sólo números"), !this.$v.contactPhone.minLength && errors.push("Ingresar como mínimo 9 números");
            return errors;
        }
    }),
    methods: {
        onSubmit: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var results, messagePhone, webSiteUrl, linkAPP;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.$v.$touch();

                                if (!this.$v.$invalid) {
                                    _context.next = 3;
                                    break;
                                }

                                return _context.abrupt("return");

                            case 3:

                                this.sending = true;

                                _context.prev = 4;
                                _context.next = 7;
                                return _Promise.all([this.$store.dispatch("affiliations/form/postVerifiedPhone1", {
                                    phone: this.contactPhone
                                })]);

                            case 7:
                                results = _context.sent;
                                messagePhone = '';


                                if (!results[0].code) messagePhone = "Tel\xE9fono de Usuario: " + results[0].message + "\n";

                                if (!messagePhone) {
                                    _context.next = 15;
                                    break;
                                }

                                this.$swal('Aviso', messagePhone, 'warning');
                                this.sending = false;
                                _context.next = 21;
                                break;

                            case 15:
                                webSiteUrl = this.webSiteUrl ? this.webSiteUrl.toLowerCase() : '';
                                linkAPP = this.linkApp ? this.linkApp.toLowerCase() : "";


                                if (this.isPagoWeb) linkAPP = '';else webSiteUrl = '';

                                console.log(webSiteUrl, linkAPP);

                                _context.next = 21;
                                return this.$store.dispatch("affiliations/form/saveVirtualCommerceData", {
                                    webSiteUrl: webSiteUrl,
                                    nameAPP: this.nameApp || "",
                                    linkAPP: linkAPP,
                                    idPlatform: this.platform || 0,
                                    idTypeOfDevelopment: this.development.value || "",
                                    enterpriseName: this.companyName || "",
                                    contactName: this.contactName || "",
                                    contactEmail: this.contactEmail || "",
                                    contactCellphone: this.contactPhone || ""
                                });

                            case 21:
                                _context.next = 26;
                                break;

                            case 23:
                                _context.prev = 23;
                                _context.t0 = _context["catch"](4);

                                this.$controlMessage(_context.t0);

                            case 26:
                                this.sending = false;
                                this.errorMessage = null;

                            case 28:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[4, 23]]);
            }));

            function onSubmit() {
                return _ref.apply(this, arguments);
            }

            return onSubmit;
        }()
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/virtual-commerce-data.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/virtual-commerce-data.vue
// module chunks = 0 1 2 3